import { Container, injected } from 'brandi';
import { TOKENS } from './tokens';
import { FirebaseAuthenticationHandler } from '../../infra/firebase/gateways';

export function bindGateways(container: Container): Container {
  container.bind(TOKENS.authHandler).toInstance(FirebaseAuthenticationHandler).inSingletonScope();

  injected(FirebaseAuthenticationHandler, TOKENS.userRepository);
  return container;
}
